import EditableModal from './EditableModal'

export default EditableModal
